module.exports = __webpack_public_path__ + "static/media/icr_qr.e3bc9d58.png";